import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinhinjewadi() {



  const cardData =
  {
    keyword: 'Corporate Cab Services in Hinjewadi',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services in Hinjewadi',
    headingDescription: ' Pune Corporate Cars India Private Limited offers premium Corporate Cab Services in Hinjewadi, perfectly tailored for IT parks, tech companies, and large corporate offices in this major business hub. Our fleet of executive sedans, SUVs, and luxury cars ensures smooth, safe, and punctual travel for employees, executives, and clients. Whether it is daily staff transportation, airport transfers, client visits, inter-campus travel, or VIP movement, we deliver a professional and seamless travel experience. With trained chauffeurs, flexible corporate plans, and reliable service, Pune Corporate Cars India Private Limited provides top-quality corporate mobility solutions that match the fast-paced demands of the Hinjewadi IT and business ecosystem.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

    "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],



"services": [
  {
    "name": "Hinjewadi IT Park Cab Service",
    "description": "Hinjewadi IT Park Cab Service offers reliable, punctual, and corporate-grade transportation for employees working in Hinjewadi Phase 1, Phase 2, and Phase 3. With AC sedans, SUVs, and shuttle vans, we ensure smooth travel during peak office hours and shift timings. Our verified chauffeurs, GPS-enabled vehicles, and clean interiors guarantee a safe and comfortable daily commute. Hinjewadi IT Park Cab Service is the preferred choice for IT companies seeking dependable employee mobility."
  },
  {
    "name": "Phase 1 Corporate Cab",
    "description": "Phase 1 Corporate Cab provides premium cab services specifically for companies and tech parks located in Hinjewadi Phase 1. Whether for daily office commute, executive movement, client visits, or airport transfers, our service ensures punctual and professional travel. Vehicles are well-maintained, comfortable, and driven by courteous chauffeurs. Phase 1 Corporate Cab offers smooth, clean, and efficient transportation for Phase 1 businesses."
  },
  {
    "name": "Phase 2 Employee Cab",
    "description": "Phase 2 Employee Cab delivers safe, timely, and structured transportation for employees working in Hinjewadi Phase 2 IT hubs. Our service includes shift-based cab scheduling, multi-route operations, and verified drivers for secure travel. AC vehicles, clean seating, and real-time tracking ensure complete reliability. Phase 2 Employee Cab is ideal for IT companies and BPOs requiring dependable daily mobility."
  },
  {
    "name": "Phase 3 Tech Park Cab",
    "description": "Phase 3 Tech Park Cab offers well-managed cab services for employees commuting to Hinjewadi Phase 3 corporate campuses. Designed for large IT firms and multinational operations, the service includes scheduled pickups, GPS tracking, safe night travel, and comfortable AC vehicles. Phase 3 Tech Park Cab ensures smooth, punctual, and stress-free commuting for corporate teams."
  },
  {
    "name": "Hinjewadi Employee Shuttle",
    "description": "Hinjewadi Employee Shuttle provides high-capacity transportation with AC buses, tempo travellers, and shuttle vans serving key IT zones. Perfect for companies with large teams, the service supports shift operations, fixed routes, and group commuting. Our shuttle service ensures smooth employee movement while reducing traffic load and improving travel efficiency. Hinjewadi Employee Shuttle is ideal for medium and large enterprises."
  },
  {
    "name": "Staff Transport Hinjewadi",
    "description": "Staff Transport Hinjewadi delivers safe, consistent, and punctual office commute services for employees across Hinjewadi. We manage early-morning and late-night shifts with strong safety protocols, GPS-enabled vehicles, and professional drivers. AC cars, shuttle vans, and minibuses support small and large team requirements. Staff Transport Hinjewadi ensures smooth and dependable daily travel for organizations."
  },
  {
    "name": "Best Corporate Cabs Hinjewadi",
    "description": "Best Corporate Cabs Hinjewadi provides premium corporate travel services with high-comfort sedans, SUVs, and executive vehicles. Ideal for meetings, office commute, client visits, and airport transfers, our service is known for punctuality, cleanliness, and professionalism. Companies benefit from flexible plans, monthly contracts, and reliable drivers. Best Corporate Cabs Hinjewadi guarantees a top-class travel experience."
  },
  {
    "name": "Hinjewadi Office Pickup Drop",
    "description": "Hinjewadi Office Pickup Drop offers structured pickup and drop services tailored for IT firms and corporate parks. Our service ensures employees reach work safely and on time with fixed schedules, optimized routes, and verified chauffeurs. AC vehicles and real-time monitoring enhance the travel experience. Hinjewadi Office Pickup Drop is ideal for companies with daily transportation needs."
  },
  {
    "name": "Hinjewadi Business Travel Cabs",
    "description": "Hinjewadi Business Travel Cabs provides professional travel solutions for executives, managers, and corporate visitors. Whether for meetings, airport transfers, or corporate events, we offer clean sedans and SUVs driven by trained chauffeurs. With flexible booking and premium service, Hinjewadi Business Travel Cabs ensures smooth and efficient business travel."
  },
  {
    "name": "IT Employee Cab Hinjewadi",
    "description": "IT Employee Cab Hinjewadi provides reliable transportation specifically tailored for tech employees. Our service supports shift-based travel, night commute safety, and multi-route scheduling. AC vehicles, monitored travel, and trained drivers ensure employee comfort and security. IT Employee Cab Hinjewadi is trusted by IT parks and corporate campuses across all phases."
  },
  {
    "name": "Monthly Corporate Cabs Hinjewadi",
    "description": "Monthly Corporate Cabs Hinjewadi offers long-term, business-friendly cab rentals with dedicated drivers and predictable billing. Ideal for executives, field teams, and daily office commute, our service ensures uninterrupted vehicle availability. Cars are clean, sanitized, and professionally managed. Monthly Corporate Cabs Hinjewadi delivers consistent and hassle-free transportation month after month."
  },
  {
    "name": "Corporate Sedan Rental Hinjewadi",
    "description": "Corporate Sedan Rental Hinjewadi provides executive sedans like Dzire, Etios, Honda City, and Verna for comfortable and professional corporate travel. Ideal for client meetings, airport runs, and daily commute, our sedans offer smooth rides and premium comfort. Corporate Sedan Rental Hinjewadi ensures punctuality, professionalism, and a premium travel experience."
  },
  {
    "name": "Corporate SUV Cab Hinjewadi",
    "description": "Corporate SUV Cab Hinjewadi offers spacious and premium SUVs such as Ertiga, Innova, and Crysta for corporate travel. These vehicles provide extra comfort, strong AC, and ample luggage capacity, making them ideal for long routes and executive group travel. Corporate SUV Cab Hinjewadi ensures comfortable and safe mobility for business needs."
  },
  {
    "name": "Corporate Fleet Provider Hinjewadi",
    "description": "Corporate Fleet Provider Hinjewadi offers managed fleet solutions with sedans, SUVs, vans, and tempo travellers assigned to your organization. We handle driver allocation, maintenance, replacements, and route planning. Designed for companies with large mobility needs, Corporate Fleet Provider Hinjewadi ensures smooth, scalable, and centralized travel management."
  },
  {
    "name": "Outstation Corporate Cabs Hinjewadi",
    "description": "Outstation Corporate Cabs Hinjewadi provides comfortable and safe intercity travel for corporate meetings, site visits, and outstation events. Vehicles include sedans and SUVs driven by experienced chauffeurs familiar with highway routes. Whether it's Pune–Mumbai, Nashik, Kolhapur, or other destinations, Outstation Corporate Cabs Hinjewadi ensures smooth, timely, and reliable long-distance travel."
  }
],
"tableData": [
  ["Hinjewadi IT Park Cab Service", "Phase 1 Corporate Cab"],
  ["Phase 2 Employee Cab", "Phase 3 Tech Park Cab"],
  ["Hinjewadi Employee Shuttle", "Staff Transport Hinjewadi"],
  ["Best Corporate Cabs Hinjewadi", "Hinjewadi Office Pickup Drop"],
  ["Hinjewadi Business Travel Cabs", "IT Employee Cab Hinjewadi"],
  ["Monthly Corporate Cabs Hinjewadi", "Corporate Sedan Rental Hinjewadi"],
  ["Corporate SUV Cab Hinjewadi", "Corporate Fleet Provider Hinjewadi"],
  ["Outstation Corporate Cabs Hinjewadi", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Hinjewadi",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable and professional corporate cab services in Hinjewadi, ensuring smooth and efficient commuting for employees and executives."
  },
  {
    "WhyChooseheading": "Perfect for IT Parks & Tech Companies",
    "WhyChoosedescription": "Our services are ideal for companies in Rajiv Gandhi Infotech Park (Phases 1, 2, and 3), offering punctual and hassle-free transportation for large and small teams."
  },
  {
    "WhyChooseheading": "Comfortable & Clean Vehicles",
    "WhyChoosedescription": "All our cabs are regularly maintained and sanitized to ensure a safe, hygienic, and comfortable commute every day."
  },
  {
    "WhyChooseheading": "Transparent Corporate Pricing",
    "WhyChoosedescription": "Enjoy clear and competitive pricing with no hidden charges, suitable for daily, monthly, or large-scale corporate travel needs."
  },
  {
    "WhyChooseheading": "Flexible Pick-Up & Drop Plans",
    "WhyChoosedescription": "Choose from customized pick-and-drop schedules designed to match office timings and employee shifts in Hinjewadi."
  },
  {
    "WhyChooseheading": "Experienced & Trained Chauffeurs",
    "WhyChoosedescription": "Our professional drivers ensure safe driving, punctuality, and a smooth travel experience for all corporate passengers."
  },
  {
    "WhyChooseheading": "24/7 Corporate Support",
    "WhyChoosedescription": "Our dedicated support team is available round-the-clock to assist with bookings, shift changes, and urgent travel needs."
  },
  {
    "WhyChooseheading": "Easy & Fast Booking",
    "WhyChoosedescription": "Book your corporate cab for Hinjewadi quickly through our online system or by phone, with fast confirmation and dependable service."
  }
]





















  }

const faqData = [
  {
    question: 'Does Pune Corporate Cars India Private Limited offer corporate cab services in Hinjewadi?',
    answer: 'Yes, Pune Corporate Cars India Private Limited provides reliable and professional corporate cab services in Hinjewadi, covering all IT parks and business zones.',
  },
  {
    question: 'How can I book a corporate cab in Hinjewadi with Pune Corporate Cars India Private Limited?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services in Hinjewadi?',
    answer: 'We offer hatchbacks, sedans, SUVs, tempo travellers, and luxury cars to meet various corporate travel needs.',
  },
  {
    question: 'Are your drivers trained for corporate transportation in Hinjewadi?',
    answer: 'Yes, our drivers are highly trained, professional, punctual, and familiar with all major Hinjewadi Phase 1, Phase 2, and Phase 3 routes.',
  },
  {
    question: 'Do you offer daily, weekly, or monthly corporate cab plans in Hinjewadi?',
    answer: 'Absolutely. We offer flexible corporate cab packages including daily, weekly, and monthly plans tailored for IT companies in Hinjewadi.',
  },
  {
    question: 'Is your corporate cab service available 24×7 in Hinjewadi?',
    answer: 'Yes, we provide round-the-clock availability to support all corporate travel shifts and schedules.',
  },
  {
    question: 'What safety measures do you follow for corporate cabs in Hinjewadi?',
    answer: 'All vehicles are regularly sanitized, and drivers follow strict hygiene and safety protocols.',
  },
  {
    question: 'What payment methods are accepted for corporate cab services?',
    answer: 'We accept UPI, credit/debit cards, net banking, digital wallets, and corporate invoicing.',
  },
  {
    question: 'Is customer support available during the corporate cab service?',
    answer: 'Yes, our 24×7 dedicated customer support team is available to assist you throughout your service duration.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Pawar',
    feedback: 'Excellent corporate cab service in Hinjewadi. The drivers are punctual and the cars are always clean. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Nidhi Kulkarni',
    feedback: 'Our IT team relies on Pune Corporate Cars India Private Limited daily. Very professional and reliable service in Hinjewadi.',
    rating: 5,
  },
];










































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Hinjewadi",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cabs-hinjewadi.jpg", // replace with actual image URL
  "description": "Reliable corporate cab services in Hinjewadi, Pune, providing employee shuttles, office pickup and drop, IT park transport, and business travel cabs. Pune Corporate Cars India Private Limited offers chauffeur-driven sedans, SUVs, and outstation cabs for corporate clients in Hinjewadi.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // update if needed
    "ratingCount": "4600", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-hinjewadi"
  }
};





  return (
    <div>
<Helmet>
  <title>Corporate Cab Services in Hinjewadi | Employee & Office Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Hinjewadi, Pune, providing employee shuttles, office pickup and drop, IT park transport, and business travel cabs. Pune Corporate Cars India Private Limited offers chauffeur-driven sedans, SUVs, and outstation cabs for corporate clients in Hinjewadi."
  />

  <meta
    name="keywords"
    content="Hinjewadi IT Park Cab Service, Phase 1 Corporate Cab, Phase 2 Employee Cab, Phase 3 Tech Park Cab, Hinjewadi Employee Shuttle, Staff Transport Hinjewadi, Best Corporate Cabs Hinjewadi, Hinjewadi Office Pickup Drop, Hinjewadi Business Travel Cabs, IT Employee Cab Hinjewadi, Monthly Corporate Cabs Hinjewadi, Corporate Sedan Rental Hinjewadi, Corporate SUV Cab Hinjewadi, Corporate Fleet Provider Hinjewadi, Outstation Corporate Cabs Hinjewadi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/10.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinhinjewadi;